import axios, { AxiosResponse } from 'axios';
import { put, call } from 'redux-saga/effects';

// TYPES
import { Dictionary } from '@/types/app.types';

// CONSTANTS
import { APP_GET_DICTIONARY, APP_SWITCH_PARTNER } from '@/constants/api';

// UTILITY
import { showErrorNotification } from '@/utility/saga';

import {
  getAppDictionarySuccessAction,
  getAppDictionaryFailAction,
  switchDefaultPartnerAction,
  switchDefaultPartnerSuccessAction,
  switchDefaultPartnerFailAction,
} from '@/store/slices/app.slice';

export function* getAppDictionarySaga() {
  try {
    const { data: respData }: AxiosResponse<Dictionary> = yield axios.get(APP_GET_DICTIONARY);

    yield put(getAppDictionarySuccessAction({ data: respData }));
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put(getAppDictionaryFailAction());
  }
}

export function* switchDefaultPartnerSaga(action: ReturnType<typeof switchDefaultPartnerAction>) {
  const { partnerId, onSuccess } = action.payload;

  try {
    yield axios.post(APP_SWITCH_PARTNER, {
      partner_id: partnerId,
    });

    yield put(switchDefaultPartnerSuccessAction());

    if (onSuccess?.call) onSuccess();
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put(switchDefaultPartnerFailAction());
  }
}

export default getAppDictionarySaga;
